
define('text!templates/modules/questionnaire/questions/list/options/options-list.html',[],function () { return '<div class="list-content">\n\n    <div class="list-items clearfix"></div>\n    <div class="add-option"></div>\n</div>\n';});

